module.exports = __webpack_public_path__ + "static/img/jdxyyyq_2.242a361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/jdxyyyq_2.jpg
// module id = zRYm
// module chunks = 15